
import DialogView from './DialogView.js';

class ConfirmDialogView extends DialogView {

    initialize(opts){
        super.initialize(opts);

        const cancelCallback = this.model.get('cancel');

        this.buttons.push({
            text: 'Cancel',
            click: () => {

                if (typeof cancelCallback === 'function') {
                    cancelCallback();
                }
                
                this.closeModal();
            }
        });
    }

    closeModal() {
        $('#dialog').remove();
    }
}

export default ConfirmDialogView;